export default __webpack_public_path__ + "static/IDMC_GRID_2022 En bref-Nombre total de PDI-440be330197ad74e7036b0470a46cb03.jpg";